import axios from './axios';

/**
 * Get current user's signature
 */
export const getMySignature = async () => {
  const response = await axios.get('/user-signatures');
  return response.data;
};

/**
 * Create or update signature for current user
 */
export const createOrUpdateSignature = async (signatureBlob) => {
  const response = await axios.put('/user-signatures', {
    signature_blob: signatureBlob
  });
  return response.data;
};

/**
 * Delete current user's signature
 */
export const deleteSignature = async () => {
  const response = await axios.delete('/user-signatures');
  return response.data;
};